// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","headerTitle":"Header_headerTitle__Vfl4P"};